<template>
  <vs-row>
    <vs-row>
      <vs-col vs-lg="4" vs-sm="4" vs-xs="12" style="padding: 5px">
        <vs-input
          v-model="fieldInfo.label"
          type="text"
          name="customFieldsname"
          v-validate="'required'"
          label="Field Name"
          placeholder=""
          style="width: 100%"
        />
      </vs-col>
      <vs-col vs-lg="4" vs-sm="4" vs-xs="12" style="padding: 5px">
        <label class="vs-input--label">Data type</label>
        <v-select
          :disabled='!fieldInfo.isNew'
          :options="fieldTypes"
          v-model="fieldInfo.type"
          :reduce="(el) => el.value"
          label="label"
        />
      </vs-col>
      <vs-col
        vs-lg="2"
        vs-sm="2"
        vs-xs="12"
        style="padding: 5px"
      >
        <label class="vs-input--label">Required</label>
        <vs-checkbox
          v-model="fieldInfo.required">
        </vs-checkbox>
      </vs-col>
      <vs-col
        v-if="this.fieldInfo.isNew"
        vs-lg="2"
        vs-sm="2"
        vs-xs="12"
        style="padding: 5px"
      >
        <label class="vs-input--label"></label>
        <!-- @click.native https://github.com/lusaxweb/vuesax/issues/611 -->
        <vs-button
          color="primary"
          type="filled"
          icon="remove"
          size="small"
          @click.native="removeField"
        >
        </vs-button>
      </vs-col>
    </vs-row>
    <CustomOptions
      v-if="fieldInfo.type === 'options'"
      :initOptions="fieldInfo.options"
      @optionsUpdated="updateOptions"
      :editable="fieldInfo.isNew"
    />

  </vs-row>
</template>

<script>
import CustomOptions from './CustomOptions';

export default {
  name: "Field",
  components: {
    CustomOptions
  },
  props: {
    fieldInitState: {
      required: true,
      type: Object
    }
  },
  data: function () {
    return {
      fieldTypes: [
        { label: "Text", value: "text" },
        { label: "Number", value: "number" },
        { label: "Date", value: "date" },
        { label: "Boolean", value: "boolean" },
        { label: "Options", value: "options" },
      ],
      fieldInfo: {  ...this.fieldInitState }
    };
  },
  methods: {
    removeField () {
      console.log('I want to remove ', this.$vnode.key)
      this.$emit('removeField', this.$vnode.key);
    },
    updateOptions (options) {
      this.fieldInfo = { ...this.fieldInfo, options };
    }
  },
  watch: {
    fieldInfo: {
      handler: function (field) {
        if (field.isNew) {
          if (field.type === 'options') {
            if (field.label && field.options) {
              this.$emit('newFieldInfoCompleted', { field, index: this.$vnode.key });
            }
          } else if (field.label && field.type) {
            this.$emit('newFieldInfoCompleted', { field, index: this.$vnode.key });
          }
        } else {
          this.$emit('configuredFieldUpdated', { field, index: this.$vnode.key });
        }
        // validate a complete object to update parent component
      },
      deep: true,
    },
  },
};
</script>
